import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { lazy, Suspense, useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import { useAppDispatch } from "./utils/hooks";
import { loadSettings } from "./redux/slices/settingsSlice";
import Footer from "./components/Footer";
import { localeData } from "./data/locale";
import fetchIntercept from "fetch-intercept";
import Header from "./components/Header";
// images
import headerLogo from "./images/equipments-logo.png";
import footerLogo from "./images/equipments-footer-logo.png";
import heroBg from "./images/webp/hero-bg-2.webp";
import heroBg2x from "./images/webp/hero-bg-2@2x.webp";
import heroLogo from "./images/hero-logo-2.png";
import aboutImg from "./images/equip-about.png";
import aboutImgWebp from "./images/webp/equip-about.webp";
import dummyAgency from "./images/dummy-agency.png";
import { localeTo } from "./utils/helpers";
// pages
const Landing = lazy(() => import("./pages/Landing"));
const News = lazy(() => import("./pages/News"));
const Jobs = lazy(() => import("./pages/Jobs"));

const headerNav = [
  {
    path: "/equipments",
    exact: true,
    name: localeData.home,
  },
  {
    path: "/equipments#about",
    exact: false,
    name: localeData.about,
  },
  {
    path: "/equipments#news",
    exact: false,
    name: localeData.news,
  },
  {
    path: "/equipments#works",
    exact: false,
    name: localeData.ourAgencies,
  },
  {
    path: "/equipments#partners",
    exact: false,
    name: localeData.partners,
  },
  {
    path: "/equipments#certificates",
    exact: false,
    name: localeData.certificates,
  },
  {
    path: "/equipments#branches",
    exact: false,
    name: localeData.branches,
  },
  {
    path: "/equipments/jobs",
    exact: false,
    name: localeData.jobs,
  },
];

const footerNav = [
  {
    path: "/contracting",
    name: localeData.cont,
  },
  {
    path: "/equipments",
    name: localeData.equipments,
  },
  {
    path: "/transport",
    name: localeData.transport,
  },
  {
    path: "/equipments",
    name: localeData.home,
  },
  {
    path: "/equipments#about",
    name: localeData.about,
  },
  {
    path: "/equipments#news",
    name: localeData.news,
  },
  {
    path: "/equipments#works",
    name: localeData.ourAgencies,
  },
  {
    path: "/equipments#branches",
    name: localeData.branches,
  },
  {
    path: "/equipments/jobs",
    name: localeData.jobs,
  },
];

function Contracting() {
  const dispatch = useAppDispatch();

  // mount logic
  useEffect(() => {
    // add Website-Key header to all fetch requests
    const unregister = fetchIntercept.register({
      request(url, config = {}) {
        config.headers = {
          ...config.headers,
          "Website-Key": "satc_equipments",
        };
        return [url, config];
      },
    });
    dispatch(loadSettings());
    document.title = localeData.equipments;
    return () => unregister();
  }, []); // eslint-disable-line

  return (
    <>
      <Header nav={headerNav} logo={headerLogo} />
      <Suspense
        fallback={
          <div className="text-center page-placeholder">
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: "28px" }} />}
            />
          </div>
        }
      >
        <Switch>
          <Route path="/equipments" exact>
            <ErrorBoundary>
              <Landing
                heroBg={heroBg}
                heroBg2x={heroBg2x}
                heroLogo={heroLogo}
                heroSlogan={localeData.bestEquip}
                aboutImg={aboutImg}
                aboutImgWebp={aboutImgWebp}
                aboutImgW="756"
                aboutImgH="583"
                worksTitle={localeData.ourAgencies}
                works={[
                  {
                    to: "/equipments/agencies",
                    src: dummyAgency,
                    title: localeData.agency,
                  },
                  {
                    to: "/equipments/agencies#agency-4",
                    src: dummyAgency,
                    title: localeData.agency,
                  },
                  {
                    to: "/equipments/agencies#agency-3",
                    src: dummyAgency,
                    title: localeData.agency,
                  },
                  {
                    to: "/equipments/agencies#agency-2",
                    src: dummyAgency,
                    title: localeData.agency,
                  },
                  {
                    to: "/equipments/agencies#agency-1",
                    src: dummyAgency,
                    title: localeData.agency,
                  },
                ]}
              />
            </ErrorBoundary>
          </Route>
          <Route path="/equipments/news/:id">
            <ErrorBoundary>
              <News siteName={localeData.equipments} />
            </ErrorBoundary>
          </Route>
          <Route path="/equipments/agencies">
            <ErrorBoundary>
              <div className="page">
                <div className="container">
                  <h1>لم يتم دعم الوكالات بعد!</h1>
                </div>
              </div>
            </ErrorBoundary>
          </Route>
          <Route path="/equipments/jobs">
            <ErrorBoundary>
              <Jobs />
            </ErrorBoundary>
          </Route>
          <Redirect to={localeTo("/404")} />
        </Switch>
      </Suspense>
      <Footer logo={footerLogo} nav={footerNav} />
    </>
  );
}

export default Contracting;
